import { render, staticRenderFns } from "./PerformanceComingSoonPage.vue?vue&type=template&id=2303dbb0&scoped=true"
import script from "./PerformanceComingSoonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceComingSoonPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PerformanceComingSoonPage.vue?vue&type=style&index=0&id=2303dbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303dbb0",
  null
  
)

export default component.exports